{
  "login": {
    "title": "Welcome back",
    "lead": "Sign in with the email you used to buy Baby Plan.",
    "email": "Email",
    "password": "Password",
    "submit": "Sign in",
    "forgot": "Forgot password?",
    "helpLink": "Sign-in help",
    "emailPlaceholder": "you@example.com",
    "passwordPlaceholder": "Your password",
    "helpTitle": "Bought Baby Plan but can't sign in?",
    "helpText": "Your password is in the email we sent after you bought it. You can also write to us:"
  },
  "forgot": {
    "title": "Reset your password",
    "lead": "We'll email you a link to set a new password.",
    "submit": "Send the link",
    "sent": "If there is an account for {{email}}, we just sent it a link to set a new password. The link works for one hour.",
    "back": "Back to sign in",
    "sentTitle": "Check your email",
    "spam": "Nothing after a few minutes? Look in Spam or Promotions.",
    "again": "Send it again"
  },
  "reset": {
    "title": "Set a new password",
    "password": "New password",
    "hint": "At least 8 characters.",
    "submit": "Save password",
    "saved": "Your password is saved.",
    "toLogin": "Sign in",
    "badLink": "This link has expired or was already used. Ask for a new one.",
    "placeholder": "At least 8 characters",
    "lead": "You'll use it with your email to sign in on any phone."
  },
  "errors": {
    "invalid_credentials": "That email and password don't match. Check them or reset your password.",
    "too_many_attempts": "Too many attempts. Wait a few minutes and try again.",
    "crm_unavailable": "We can't sign you in right now. Try again in a minute.",
    "offline": "You're offline. Connect to the internet to sign in.",
    "invalid_token": "This link has expired or was already used. Ask for a new one.",
    "validation_error": "Check the fields and try again.",
    "generic": "Something went wrong. Try again."
  },
  "field": {
    "show": "Show password",
    "hide": "Hide password"
  }
}
